import { StyledCopyright } from './styles';

export const Copyright = () => {
  return <StyledCopyright>Создано 2021</StyledCopyright>;
};
